import React, { useState, useEffect } from 'react';
import CardTwo from './CardTwo';
import HeroSection from './HeroSection';
import Breadcrumb from './Breadcrumb';

function Hardware() {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  // Update `isMobileView` on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cardsData = [
    {
      img: '/img/custom-board.jpg',
      title: "Customized Board Design",
      points: [
  "Modular multi-board systems for scalability and easy maintenance.",
  "Integration of mixed-signal components for enhanced functionality and performance.",
  "Design of custom PCBs with efficient power distribution and signal integrity.",
  "Use of advanced simulation tools for signal, thermal, and mechanical analysis.",
  "Optimized layout for reduced noise and interference in high-speed circuits.",
  "Support for custom connectors and peripheral interfaces based on project requirements.",
  "Selection of appropriate components considering cost, performance, and availability.",
  "Prototyping and testing to ensure the design meets functional and safety requirements.",
  "Compliance with industry standards for certification (CE, UL, RoHS)."
],

    },
    {
      img: '/img/pcb-2.jpg',
      title: 'Multi Core Processor Design ',
      points: [
  "Designing multi-core processors for parallel processing and high-performance computing.",
  "Efficient task scheduling and load balancing across multiple cores for optimal performance.",
  "Advanced signal integrity techniques to ensure reliable communication between cores.",
  "Development of interconnects and communication protocols for multi-core coordination.",
  "Optimization for low-latency and real-time processing in embedded systems.",
  "Integration of power management techniques to reduce energy consumption in multi-core processors.",
  "Thermal management solutions, including heat dissipation and cooling strategies for high-power applications.",
  "Implementation of fault tolerance and redundancy mechanisms to ensure system reliability.",
  "Support for advanced instruction sets and hardware accelerators to improve processing efficiency."
],

    },
    {
      img: '/img/pcb-3.jpg',
      title: 'Low Power Design ',
      points: [
  "Low-power designs for energy-efficient systems and extended battery life.",
  "Optimized power gating and dynamic voltage/frequency scaling (DVFS) for reduced energy consumption.",
  "Use of low-power components and efficient power management circuits.",
  "Signal optimization techniques to reduce power loss and improve system efficiency.",
  "Efficient PCB routing techniques to minimize power consumption and electromagnetic interference.",
  "Power consumption analysis and simulation tools for precise design adjustments.",
  "Designing for ultra-low standby and operational power modes.",
  "Prototyping and testing to validate low-power performance in real-world conditions.",
  "Compliance with energy efficiency standards such as Energy Star and EPEAT."
],

    },
  ];

  // Navigation functions for carousel
  const nextCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardsData.length);
  };

  const prevCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex - 1 + cardsData.length) % cardsData.length);
  };

  return (
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Hardware Design Services"
        backgroundImage="/img/hardware-2.jpg"
        punchline="Your gateway to cutting-edge hardware solutions"
      />

      <Breadcrumb />

      <div className="aboutInfo">
        <div className="container hardware">
          <div className="card2-container">
            {isMobileView
              ? // Render all cards in stacked layout for mobile view
                cardsData.map((card, index) => (
                  <CardTwo
                    key={index}
                    img={card.img}
                    title={card.title}
                    points={card.points}
                  />
                ))
              : // Render one card with navigation for larger screens
                <>
                  <button onClick={prevCard} className="arrow-button arrow-left">
                    <img src="/img/leftarrow.png" alt="Previous" />
                  </button>

                  <CardTwo
                    img={cardsData[currentCardIndex].img}
                    title={cardsData[currentCardIndex].title}
                    points={cardsData[currentCardIndex].points}
                  />

                  <button onClick={nextCard} className="arrow-button arrow-right">
                    <img src="/img/right-arrow.png" alt="Next" />
                  </button>
                </>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hardware;
